export default __webpack_public_path__ + "static/media/W-logo-title.3c5a34f3.svg";